var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 60,
    viewBox: "0 0 223 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.75 31.7C94.8167 33.0333 95.0167 34.15 95.35 35.05C95.6833 35.95 96.2167 36.7667 96.95 37.5L96.55 38H87.85L87.5 37.1C88.6 36.8 89.3 36.5 89.6 36.2C89.9333 35.9 90.1 35.35 90.1 34.55C90.1 34.1167 89.8333 30.0667 89.3 22.4L89 18.05L82.25 37.25H80.85L74.15 18.2L73.45 29.6C73.3167 31.2 73.25 32.3167 73.25 32.95C73.25 33.8167 73.35 34.5833 73.55 35.25C73.7833 35.8833 74.2 36.6333 74.8 37.5L74.35 38H68.8L68.5 37.1C69.3667 36.8333 69.9833 36.6 70.35 36.4C70.75 36.2 71.0167 35.9167 71.15 35.55C71.3167 35.1833 71.4333 34.6167 71.5 33.85L72.1 24.25C72.2667 22.0167 72.35 20.55 72.35 19.85C72.35 18.7167 72.2167 17.8833 71.95 17.35C71.7167 16.8167 71.1667 16.1333 70.3 15.3L70.65 14.65H77.95L83.1 30.2L88.55 14.65H95L95.5 15.2C94.8667 16.1333 94.4333 16.9 94.2 17.5C94 18.1 93.9 18.8833 93.9 19.85C93.9 20.4833 93.9667 21.4667 94.1 22.8L94.75 31.7ZM108.68 36.8C109.647 36.8 110.497 36.6333 111.23 36.3C111.964 35.9333 112.68 35.3333 113.38 34.5L113.98 34.95C113.214 36.05 112.23 36.9167 111.03 37.55C109.864 38.15 108.58 38.45 107.18 38.45C105.647 38.45 104.264 38.0833 103.03 37.35C101.83 36.6167 100.88 35.6167 100.18 34.35C99.4805 33.05 99.1305 31.5833 99.1305 29.95C99.1305 27.35 99.9138 25.2833 101.48 23.75C103.08 22.1833 105.197 21.4 107.83 21.4C109.697 21.4 111.214 21.85 112.38 22.75C113.58 23.6167 114.18 24.75 114.18 26.15C114.18 27.75 113.497 29.0333 112.13 30C110.797 30.9333 108.964 31.4 106.63 31.4C105.697 31.4 104.847 31.3333 104.08 31.2C104.247 32.9333 104.747 34.3 105.58 35.3C106.414 36.3 107.447 36.8 108.68 36.8ZM107.28 22.6C106.247 22.6 105.43 23.2333 104.83 24.5C104.264 25.7333 103.98 27.4667 103.98 29.7V30.5C104.347 30.5 104.797 30.4667 105.33 30.4C106.73 30.2333 107.797 29.7833 108.53 29.05C109.297 28.2833 109.68 27.2833 109.68 26.05C109.68 25.05 109.447 24.2333 108.98 23.6C108.547 22.9333 107.98 22.6 107.28 22.6ZM135.467 36.4C134.233 37.7667 132.783 38.45 131.117 38.45C130.083 38.45 129.317 38.2333 128.817 37.8C128.317 37.3333 127.983 36.5833 127.817 35.55C126.95 36.55 126.05 37.2833 125.117 37.75C124.183 38.2167 123.15 38.45 122.017 38.45C120.35 38.45 118.983 37.7167 117.917 36.25C116.883 34.7833 116.367 32.8833 116.367 30.55C116.367 27.75 117.1 25.5333 118.567 23.9C120.033 22.2333 122.033 21.4 124.567 21.4C125.733 21.4 126.8 21.6667 127.767 22.2V16.65C127.767 16.1833 127.55 15.95 127.117 15.95H125.417L125.217 15.45C125.883 14.85 126.733 14.3833 127.767 14.05C128.8 13.6833 129.817 13.5 130.817 13.5C131.25 13.5 131.6 13.6 131.867 13.8C132.133 13.9667 132.267 14.2167 132.267 14.55V35.15C132.267 36.15 132.583 36.65 133.217 36.65C133.85 36.65 134.467 36.4 135.067 35.9L135.467 36.4ZM124.617 36.05C125.883 36.05 126.933 35.35 127.767 33.95V23.2C127.1 22.8667 126.367 22.7 125.567 22.7C122.767 22.7 121.367 25.1167 121.367 29.95C121.367 31.9167 121.633 33.4333 122.167 34.5C122.733 35.5333 123.55 36.05 124.617 36.05ZM143.077 35.15C143.077 36.15 143.394 36.65 144.027 36.65C144.66 36.65 145.277 36.4 145.877 35.9L146.277 36.4C145.044 37.7667 143.594 38.45 141.927 38.45C140.727 38.45 139.86 38.15 139.327 37.55C138.794 36.9167 138.527 35.9 138.527 34.5V24.6C138.527 24.1333 138.31 23.9 137.877 23.9H136.327L136.177 23.35C136.844 22.7833 137.677 22.3167 138.677 21.95C139.677 21.5833 140.677 21.4 141.677 21.4C142.077 21.4 142.41 21.5 142.677 21.7C142.944 21.9 143.077 22.1667 143.077 22.5V35.15ZM138.027 16.6C138.027 16 138.36 15.3333 139.027 14.6C139.694 13.8667 140.31 13.5 140.877 13.5C141.477 13.5 142.11 13.8667 142.777 14.6C143.477 15.3333 143.827 16 143.827 16.6C143.827 17.2333 143.477 17.9167 142.777 18.65C142.11 19.35 141.477 19.7 140.877 19.7C140.31 19.7 139.694 19.35 139.027 18.65C138.36 17.9167 138.027 17.2333 138.027 16.6ZM162.123 25.8C162.123 26.9 161.789 27.7667 161.123 28.4C160.456 29.0333 159.639 29.35 158.673 29.35C157.906 29.35 157.206 29.15 156.573 28.75C157.306 28.0833 157.673 27.15 157.673 25.95C157.673 24.9833 157.473 24.2 157.073 23.6C156.673 22.9667 156.089 22.65 155.323 22.65C154.456 22.65 153.739 23.3333 153.173 24.7C152.639 26.0333 152.373 27.7833 152.373 29.95C152.373 32.0167 152.756 33.6833 153.523 34.95C154.323 36.1833 155.439 36.8 156.873 36.8C157.873 36.8 158.723 36.6167 159.423 36.25C160.156 35.8833 160.839 35.35 161.473 34.65L162.073 35.05C161.373 36.05 160.456 36.8667 159.323 37.5C158.189 38.1333 156.873 38.45 155.373 38.45C153.039 38.45 151.123 37.6667 149.623 36.1C148.123 34.5333 147.373 32.5167 147.373 30.05C147.373 27.4167 148.156 25.3167 149.723 23.75C151.289 22.1833 153.373 21.4 155.973 21.4C157.806 21.4 159.289 21.8167 160.423 22.65C161.556 23.45 162.123 24.5 162.123 25.8ZM169.92 26.95C169.22 27.35 168.386 27.55 167.42 27.55C166.72 27.55 166.17 27.35 165.77 26.95C165.37 26.5167 165.17 25.9167 165.17 25.15C165.17 24.0167 165.72 23.1167 166.82 22.45C167.953 21.75 169.42 21.4 171.22 21.4C173.353 21.4 175.02 21.8667 176.22 22.8C177.453 23.7333 178.07 25 178.07 26.6V35.25C178.07 36.1833 178.403 36.65 179.07 36.65C179.703 36.65 180.32 36.4 180.92 35.9L181.32 36.4C180.086 37.7667 178.62 38.45 176.92 38.45C175.92 38.45 175.153 38.2 174.62 37.7C174.12 37.2 173.82 36.4167 173.72 35.35H173.52C172.986 36.3167 172.27 37.0833 171.37 37.65C170.503 38.1833 169.503 38.45 168.37 38.45C167.103 38.45 166.086 38.0667 165.32 37.3C164.553 36.5 164.17 35.4667 164.17 34.2C164.17 32.7667 164.853 31.6333 166.22 30.8C167.586 29.9667 169.436 29.55 171.77 29.55C172.203 29.55 172.82 29.5833 173.62 29.65V27.15C173.62 25.5167 173.42 24.35 173.02 23.65C172.62 22.9167 171.97 22.55 171.07 22.55C170.436 22.55 169.936 22.75 169.57 23.15C169.203 23.55 169.02 24.0667 169.02 24.7C169.02 25.7 169.32 26.45 169.92 26.95ZM170.67 35.95C172.636 35.95 173.62 34.1667 173.62 30.6C171.953 30.6 170.703 30.8833 169.87 31.45C169.036 31.9833 168.62 32.75 168.62 33.75C168.62 34.4167 168.803 34.95 169.17 35.35C169.536 35.75 170.036 35.95 170.67 35.95ZM188.381 35.15C188.381 36.15 188.698 36.65 189.331 36.65C189.965 36.65 190.581 36.4 191.181 35.9L191.581 36.4C190.415 37.7667 188.965 38.45 187.231 38.45C186.065 38.45 185.215 38.1833 184.681 37.65C184.148 37.0833 183.881 36.2 183.881 35V16.65C183.881 16.1833 183.665 15.95 183.231 15.95H181.631L181.481 15.45C182.115 14.85 182.931 14.3833 183.931 14.05C184.965 13.6833 185.981 13.5 186.981 13.5C187.415 13.5 187.748 13.6 187.981 13.8C188.248 13.9667 188.381 14.2167 188.381 14.55V35.15ZM198.635 35.15C198.635 36.15 198.952 36.65 199.585 36.65C200.218 36.65 200.835 36.4 201.435 35.9L201.835 36.4C200.668 37.7667 199.218 38.45 197.485 38.45C196.318 38.45 195.468 38.1833 194.935 37.65C194.402 37.0833 194.135 36.2 194.135 35V16.65C194.135 16.1833 193.918 15.95 193.485 15.95H191.885L191.735 15.45C192.368 14.85 193.185 14.3833 194.185 14.05C195.218 13.6833 196.235 13.5 197.235 13.5C197.668 13.5 198.002 13.6 198.235 13.8C198.502 13.9667 198.635 14.2167 198.635 14.55V35.15ZM219.289 21.5V38C219.289 40.6333 218.522 42.6667 216.989 44.1C215.489 45.5667 213.389 46.3 210.689 46.3C209.022 46.3 207.672 45.9833 206.639 45.35C205.606 44.7167 205.089 43.8833 205.089 42.85C205.089 41.95 205.356 41.2167 205.889 40.65C206.422 40.1167 207.122 39.85 207.989 39.85C208.622 39.85 209.239 39.9833 209.839 40.25C209.239 40.85 208.939 41.6667 208.939 42.7C208.939 43.4333 209.156 44.0333 209.589 44.5C210.056 44.9667 210.639 45.2 211.339 45.2C213.672 45.2 214.839 43.3 214.839 39.5V33.15C214.406 34.4167 213.639 35.4667 212.539 36.3C211.472 37.1 210.322 37.5 209.089 37.5C207.622 37.5 206.539 37.05 205.839 36.15C205.139 35.25 204.789 33.8833 204.789 32.05V24.6C204.789 24.1333 204.572 23.9 204.139 23.9H202.589L202.439 23.35C203.072 22.7833 203.906 22.3167 204.939 21.95C205.972 21.5833 206.956 21.4 207.889 21.4C208.322 21.4 208.656 21.5 208.889 21.7C209.156 21.9 209.289 22.1667 209.289 22.5V32.6C209.289 34.4667 209.872 35.4 211.039 35.4C212.172 35.4 213.089 34.7167 213.789 33.35C214.489 31.9833 214.839 30.1667 214.839 27.9C214.839 26.7 214.739 25.7167 214.539 24.95C214.339 24.1833 214.022 23.5167 213.589 22.95L213.189 22.4L213.539 21.95L219.289 21.5Z",
    fill: "#000B47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4648 22.2818H36.4415L34.6573 16.724L30.4804 29.6499H27.9662L24.9945 8.82721L22.5521 20.7497H20.3699L18.2163 16.4381L15.1972 21.6725H0L14.2103 19.9627L17.0618 15.0208H19.4193L21.2366 18.658L23.9315 5.49805H26.2449L29.3832 27.4897L33.4124 15.0208H35.9056L37.6875 20.572L54.4648 22.2818Z",
    fill: "url(#paint0_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65703 29.1357C6.24452 26.3088 5.51337 23.1899 5.52224 20.0291C5.52441 17.144 6.13624 14.292 7.31755 11.6604C8.49886 9.02878 10.2229 6.67709 12.3765 4.75977L13.7416 6.2963C11.8053 8.02094 10.2554 10.1361 9.19363 12.5029C8.13185 14.8697 7.58226 17.4346 7.58095 20.0291C7.57219 22.8715 8.22933 25.6763 9.49961 28.2184L7.65703 29.1357Z",
    fill: "url(#paint1_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4316 29.7484C43.6486 33.3215 40.9219 36.3374 37.5474 38.4687C34.0708 40.6661 30.0423 41.8301 25.9307 41.8254C21.8802 41.8272 17.9095 40.6978 14.4651 38.5643C11.0207 36.4308 8.23909 33.3777 6.43304 29.7484L7.65812 29.1369L9.49409 28.2196L10.7225 27.6069C12.1284 30.4421 14.2971 32.828 16.9844 34.496C19.6718 36.1639 22.7709 37.0477 25.9329 37.0477C29.0948 37.0477 32.194 36.1639 34.8813 34.496C37.5686 32.828 39.7374 30.4421 41.1433 27.6069L42.3695 28.2196L44.2087 29.1369L45.4316 29.7484Z",
    fill: "url(#paint2_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2065 29.1368L42.3695 28.2184C44.2273 24.4745 44.7556 20.2087 43.8673 16.124C42.9789 12.0393 40.7269 8.37949 37.4824 5.74764L38.7758 4.15039C42.3833 7.07707 44.8871 11.1469 45.8743 15.6889C46.8615 20.231 46.2732 24.9742 44.2065 29.1368Z",
    fill: "url(#paint3_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0864 6.75875L11.6079 7.36366C11.7992 7.58585 12.0496 7.749 12.33 7.83402C12.6104 7.91905 12.9091 7.92245 13.1914 7.84382L16.527 6.91329C16.7778 6.84359 17.0069 6.71156 17.193 6.52947C17.3791 6.34738 17.5162 6.12115 17.5916 5.8718C17.6669 5.62245 17.6781 5.35807 17.624 5.10323C17.57 4.8484 17.4524 4.61138 17.2823 4.41421L14.9039 1.65463C14.7364 1.46015 14.5232 1.3105 14.2835 1.2192C14.0438 1.12789 13.7852 1.0978 13.5309 1.13166C13.2767 1.16551 13.0349 1.26224 12.8274 1.41309C12.6199 1.56395 12.4532 1.76419 12.3423 1.99571L10.8636 5.08645C10.7349 5.35682 10.6874 5.65882 10.7269 5.95571C10.7665 6.25261 10.8913 6.5316 11.0864 6.75875Z",
    fill: "url(#paint4_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5245 5.64157L39.003 6.24757C38.8115 6.46978 38.5609 6.63283 38.2803 6.71767C37.9997 6.8025 37.7007 6.80561 37.4184 6.72664L34.0828 5.79611C33.832 5.7264 33.603 5.59437 33.4168 5.41228C33.2307 5.2302 33.0936 5.00396 33.0182 4.75461C32.9429 4.50526 32.9317 4.24088 32.9858 3.98605C33.0398 3.73121 33.1574 3.49419 33.3275 3.29702L35.7071 0.53744C35.8745 0.342967 36.0877 0.193317 36.3274 0.10201C36.5671 0.0107038 36.8257 -0.0193826 37.08 0.0144697C37.3342 0.048322 37.576 0.145048 37.7835 0.295906C37.991 0.446763 38.1578 0.646998 38.2686 0.878524L39.7473 3.96926C39.876 4.23963 39.9235 4.54163 39.884 4.83852C39.8445 5.13542 39.7196 5.41441 39.5245 5.64157Z",
    fill: "url(#paint5_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4763 59.9998H39.3525C31.314 59.9998 24.7751 53.453 24.7751 45.4072H28.3952C28.3987 48.3152 29.5542 51.1031 31.6084 53.1594C33.6625 55.2157 36.4476 56.3725 39.3525 56.376H41.4763C44.0691 56.3727 46.5547 55.3403 48.3881 53.505C50.2214 51.6697 51.2528 49.1815 51.256 46.5861V42.96H54.875V46.5861C54.8709 50.1422 53.458 53.5515 50.9462 56.0661C48.4343 58.5808 45.0287 59.9955 41.4763 59.9998Z",
    fill: "url(#paint6_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8274 33.624H52.3035V45.1348H53.8274V33.624Z",
    fill: "url(#paint7_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0655 24.7114C52.0897 24.7116 51.136 25.0015 50.3248 25.5443C49.5136 26.0872 48.8815 26.8586 48.5083 27.7611C48.1351 28.6636 48.0376 29.6566 48.2282 30.6145C48.4188 31.5725 48.8888 32.4523 49.5789 33.1428C50.269 33.8334 51.1482 34.3035 52.1052 34.4939C53.0622 34.6842 54.0542 34.5862 54.9555 34.2122C55.8569 33.8382 56.6273 33.205 57.1692 32.3928C57.7111 31.5805 58.0002 30.6256 58 29.6489C57.9982 28.3395 57.4777 27.0844 56.5526 26.1587C55.6276 25.2331 54.3735 24.7126 53.0655 24.7114ZM53.0655 33.063C52.3912 33.0628 51.7322 32.8625 51.1717 32.4874C50.6112 32.1123 50.1743 31.5792 49.9164 30.9556C49.6585 30.332 49.5911 29.6458 49.7227 28.9839C49.8543 28.3219 50.1789 27.7138 50.6557 27.2366C51.1325 26.7593 51.7399 26.4343 52.4012 26.3026C53.0624 26.1708 53.7479 26.2383 54.3708 26.4965C54.9938 26.7547 55.5263 27.192 55.901 27.7531C56.2757 28.3142 56.4759 28.9739 56.4761 29.6489C56.474 30.5537 56.1141 31.421 55.4749 32.0608C54.8357 32.7006 53.9694 33.061 53.0655 33.063Z",
    fill: "url(#paint8_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0655 31.2053C53.9236 31.2053 54.6192 30.509 54.6192 29.65C54.6192 28.7911 53.9236 28.0947 53.0655 28.0947C52.2074 28.0947 51.5118 28.7911 51.5118 29.65C51.5118 30.509 52.2074 31.2053 53.0655 31.2053Z",
    fill: "url(#paint9_linear_33_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0266 39.3806C34.0267 39.6865 34.0083 39.992 33.9715 40.2957C33.8365 41.3754 33.4668 42.4124 32.8885 43.3338C32.3102 44.2552 31.5373 45.0385 30.6242 45.6288C29.711 46.2191 28.6797 46.602 27.6029 46.7505C26.5261 46.899 25.4298 46.8096 24.3912 46.4886C23.3526 46.1675 22.3968 45.6225 21.5912 44.892C20.7855 44.1616 20.1495 43.2633 19.7278 42.2603C19.3061 41.2574 19.1091 40.1741 19.1505 39.0868C19.1919 37.9994 19.4707 36.9343 19.9674 35.9664C24.1867 37.5288 28.85 37.3702 32.9537 35.5249C33.6586 36.687 34.0298 38.0211 34.0266 39.3806Z",
    fill: "url(#paint10_linear_33_18)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_18",
    x1: 28.7304,
    y1: 66.7023,
    x2: 26.2795,
    y2: -6.33047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_18",
    x1: 11.4359,
    y1: 67.2831,
    x2: 8.98617,
    y2: -5.72759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_18",
    x1: 27.1712,
    y1: 66.7555,
    x2: 24.7214,
    y2: -6.25521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_18",
    x1: 43.7026,
    y1: 66.2002,
    x2: 41.2528,
    y2: -6.81051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_18",
    x1: 16.2458,
    y1: 67.1219,
    x2: 13.795,
    y2: -5.88881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33_18",
    x1: 38.499,
    y1: 66.3745,
    x2: 36.0482,
    y2: -6.6362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_33_18",
    x1: 40.5622,
    y1: 66.306,
    x2: 38.1124,
    y2: -6.70467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_33_18",
    x1: 53.952,
    y1: 65.856,
    x2: 51.5023,
    y2: -7.15365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_33_18",
    x1: 54.2773,
    y1: 65.8458,
    x2: 51.8276,
    y2: -7.16492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33_18",
    x1: 54.2774,
    y1: 65.8459,
    x2: 51.8276,
    y2: -7.16488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_33_18",
    x1: 27.502,
    y1: 66.7446,
    x2: 25.0523,
    y2: -6.26608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e6b6bf57704082a4cffe32d389f9733f.svg";
export { ForwardRef as ReactComponent };